import { booleanAttribute, Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective {

  @Input({transform: booleanAttribute}) includeOverlay = false;
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: Element) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    const clickedOnOverlay = this.includeOverlay && target.closest('.cdk-overlay-connected-position-bounding-box');
    if (!(clickedInside || clickedOnOverlay)) {
      this.clickOutside.emit();
    }
  }

}
